import { ITitleViewModel } from '../models/interfaces';

export class TitleViewModel implements ITitleViewModel {
    // data members

    text: string;
    visible: boolean;

    // constructor

    constructor(text: string) {
        this.text = text;
        this.visible = true;
    }
}
